let self = null; // Parent class scope context

export default class UpdatePathByPercentageBehavior {
    constructor(parentContext) {
        self = parentContext;
    }

    updatePath(value) {
        self._currentLen = this._getPositionByPercent(value, self._totalPathLen);
    }

    _getPositionByPercent(percent, len) {
        let position = percent * len;
        return position;
    }
}


// WEBPACK FOOTER //
// ./src/components/parts/PathMover/Behavior/UpdatePathBehavior/UpdatePathByPercentageBehavior.js